import React from "react";
import { Helmet } from "react-helmet";
import BlogContent from "../../Components/BlogContent";
import Loading from "../../Components/Loading";
// import RandomBlogCardSidebar from "./Components/RandomBlogCardSidebar";
// import { webTemp } from "../../../Utils/styles";
import Comments from "../../Components/Comments";
// import BlogContent from "./Components/BlogContents";
// import "../Item/index.css";
import { useBlogSingle } from "./Hooks";
import LastBlog from "../../Components/Cards/LastBlog";
function Single() {
  const { data, loading, renderSlug, slug } = useBlogSingle();
  return (
    <>
      <Helmet>
        <title>
          {loading ? renderSlug() : `${data.blog.title} - صنعتبان`} | صنعتبان
        </title>
        {/* <meta name="description" content={renderDesc()} /> */}
        <meta name="robots" content="index, follow" />
        {/* <meta name="keywords" content={rendeKeyWords()} /> */}
        <link rel="canonical" href={window.origin + `/blogs/${slug}`} />
      </Helmet>
      <section className="blog-single-page" style={{}}>
        <div className="container">
          <div className="row flex-row-reverse">
            <div className=" col-lg-4 d-lg-block  d-none">
              <div className="importants mt-3 web-template">
                {loading ? (
                  <Loading count={1} col={3} height={30} />
                ) : (
                  <header className="mb-3 mt-3 mt-xl-0 pb-0">
                    <h5 className="fw-bold h5 border-bottom pb-2.offer-area pb-2 ">
                      مقالات پربازدید
                    </h5>
                  </header>
                )}
                <div className="items d-flex flex-wrap flex-xl-column flex-row">
                  {loading ? (
                    <Loading count={3} margin={2} col={12} height={140} />
                  ) : (
                    data &&
                    data.last_blogs.map((item, key) => (
                      <LastBlog key={key} data={item} />
                    ))
                  )}
                </div>
              </div>
            </div>

            {loading ? (
              <Loading count={1} col={8} height={800} />
            ) : (
              <div className="col-lg-8 ">
                <div className="web-template">
                  <header className="pb-0 row mb-4">
                    <div className="col-8 text-start ">
                      <h5
                        style={{
                          fontWeight: "500",
                          textAlign: "right",
                        }}
                        className="mb-2 "
                      >
                        {data && data.blog.title}
                      </h5>
                      <p
                        style={{
                          color: "#B1B1B1",
                          fontWeight: "400",
                          textAlign: "justify",
                          fontSize: "13px",
                        }}
                      >
                        {data && data && data.blog && data.blog.description}
                      </p>
                    </div>
                    <div className="col-4  d-flex flex-wrap justify-content-center justify-content-sm-end align-items-center">
                      <div className="">
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            fontWeight: "400",
                            color: "#B1B1B1",
                          }}
                        >
                          <img
                            src={require("../../Assets/images/write.png")}
                            style={{
                              width: "16px",
                              height: "16px",
                              marginLeft: "5px",
                            }}
                            alt="همه ملاقات"
                          />
                          {data.blog && data.blog.auther.fullname}
                        </h6>
                        <h6
                          style={{
                            fontSize: "14px",
                            color: "#B1B1B1",
                            fontWeight: "400",
                          }}
                        >
                          <img
                            src={require("../../Assets/images/cat.png")}
                            style={{
                              width: "16px",
                              height: "16px",
                              marginLeft: "5px",
                            }}
                            alt={
                              data &&
                              data.blog.category &&
                              data.blog.category.title
                            }
                          />
                          {data &&
                            data.blog.category &&
                            data.blog.category.title}
                        </h6>
                      </div>
                      {/* <a
                      href={`https://xn--r1a.link/share/url?url=${window.location.href}&text=${data.blog.title}`}
                      className="d-inline-block"
                      style={{ lineHeight: "unset" }}
                      aria-label="telegram"
                    >
                      <i
                        className="fab fa-telegram mx-2"
                        style={{ fontSize: 25 }}
                      ></i>
                    </a>
                    <a
                      href={`https://wa.me/?text=${data.blog.title}%0A%0A${window.location.href}`}
                      className="d-inline-block"
                      style={{ lineHeight: "unset" }}
                      aria-label="whatsapp"
                    >
                      <i
                        className="fab fa-whatsapp mx-2"
                        style={{ fontSize: 25 }}
                      ></i>
                    </a>
                    <span
                      style={{
                        background: "#d6d6d6",
                        padding: " 3px 15px",
                        color: "#444",
                        borderRadius: "8px",
                        fontSize: 12,
                      }}
                    >
                      {ToDateJalali(data.blog.created_at)}
                    </span> */}
                    </div>
                  </header>
                  <div className="blog-image mb-3">
                    <img
                      src={data?.blog?.image[0]?.url || data?.blog?.image?.url }
                      alt={data?.blog?.image?.alt || data?.blog.title}
                      className="object-fit-cover rounded-15 img-fluid"
                    />
                  </div>
                  <BlogContent loading={loading} data={data.blog} />
                </div>
                <Comments
                  rel={"blog_id"}
                  id={data?.blog?.id}
                  comments={data?.comments}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Single;
